import { FixedIncomeOfferBaseEntity } from '@genial/services';
import type { FixedIncomePositionEntity } from '@genial/services';
import { FixedIncomeRequestsFixedIncomeOfferCategoriesResponse } from '@genial/services/dist/models';
import { useSetRecoilState } from 'recoil';

import type { FixedIncomeOperationType } from '../../../pages/NewApplication/Product/components/FixedIncome/constants';
import {
  fixedIncomeOffersByFilterParams,
  fixedIncomeOffersBySearchTermParams,
  updateFixedIncomeCategoriesOptionsFilterSelector,
  updateFixedIncomeOffersAllSelector,
  updateFixedIncomeOffersBySearchTermSelector,
  updateFixedIncomeOffersOperationTypeSelector,
  updateFixedIncomeRescueOffersAllSelector,
  updateFixedIncomeRescueOffersBySearchTermParams,
  updateFixedIncomeRescueOffersBySearchTermSelector,
} from '../selectors';
import {
  FixedIncomeOffersByFilterParams,
  FixedIncomeOffersBySearchTerm,
  type FixedIncomeRescueOffersBySearchTerm,
} from '../types';

export const useFixedIncomeActions = () => {
  const setFixedIncomeOffersByFilterParams = useSetRecoilState(fixedIncomeOffersByFilterParams);
  const setFixedIncomeAllOffers = useSetRecoilState(updateFixedIncomeOffersAllSelector);
  const setFixedIncomeBySearchTermOffers = useSetRecoilState(
    updateFixedIncomeOffersBySearchTermSelector
  );
  const setFixedIncomeCategoriesOptionsFilter = useSetRecoilState(
    updateFixedIncomeCategoriesOptionsFilterSelector
  );
  const setFixedIncomeOffersOperationType = useSetRecoilState(
    updateFixedIncomeOffersOperationTypeSelector
  );
  const setFixedIncomeRescueAllOffers = useSetRecoilState(updateFixedIncomeRescueOffersAllSelector);
  const setFixedIncomeOffersBySearchTermParams = useSetRecoilState(
    fixedIncomeOffersBySearchTermParams
  );
  const setFixedIncomeRescueBySearchTermOffers = useSetRecoilState(
    updateFixedIncomeRescueOffersBySearchTermSelector
  );
  const setFixedIncomeRescueOffersBySearchTermParams = useSetRecoilState(
    updateFixedIncomeRescueOffersBySearchTermParams
  );

  const updateFixedIncomeOffersByFilterParams = (
    value: Partial<FixedIncomeOffersByFilterParams>
  ) => {
    setFixedIncomeOffersByFilterParams(value);
  };

  const updateFixedIncomeOffersBySearchTermParams = (
    value: Partial<FixedIncomeOffersBySearchTerm>
  ) => {
    setFixedIncomeOffersBySearchTermParams(value);
  };

  const updateFixedIncomeAllOffers = (value: FixedIncomeOfferBaseEntity[]) => {
    setFixedIncomeAllOffers(value);
  };

  const updateFixedIncomeBySearchTermOffers = (value: FixedIncomeOfferBaseEntity[]) => {
    setFixedIncomeBySearchTermOffers(value);
  };

  const updateFixedIncomeCategoriesOptionsFilter = (
    value: FixedIncomeRequestsFixedIncomeOfferCategoriesResponse[]
  ) => {
    setFixedIncomeCategoriesOptionsFilter(value);
  };

  const updateFixedIncomeOffersOperationType = (value: FixedIncomeOperationType) => {
    setFixedIncomeOffersOperationType(value);
  };

  const updateFixedIncomeRescueAllOffers = (value: FixedIncomePositionEntity[]) => {
    setFixedIncomeRescueAllOffers(value);
  };

  const updateFixedIncomeRescueBySearchTermOffers = (value: FixedIncomePositionEntity[]) => {
    setFixedIncomeRescueBySearchTermOffers(value);
  };

  const updateFixedIncomeResueOffersBySearchTermParams = (
    value: Partial<FixedIncomeRescueOffersBySearchTerm>
  ) => {
    setFixedIncomeRescueOffersBySearchTermParams(value);
  };

  return {
    updateFixedIncomeOffersByFilterParams,
    updateFixedIncomeOffersBySearchTermParams,
    updateFixedIncomeAllOffers,
    updateFixedIncomeBySearchTermOffers,
    updateFixedIncomeCategoriesOptionsFilter,
    updateFixedIncomeOffersOperationType,
    updateFixedIncomeRescueAllOffers,
    updateFixedIncomeRescueBySearchTermOffers,
    updateFixedIncomeResueOffersBySearchTermParams,
  };
};
